import React from "react";
import { FieldType } from "../../../services/helpers/types";
import TextField from "../TextField/TextField";
import { useTranslation } from "react-i18next";

interface AddBooleanTextFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: string) => void;
}

const AddBooleanTextField = (props: AddBooleanTextFieldProps) => {
  const { field, onFieldChange } = props;

  const { t } = useTranslation();

  const [defaultValue, setDefaultValue] = React.useState(
    field?.defaultValue ?? undefined
  );

  const handleDefaultValueChange = (value?: string) => {
    setDefaultValue(value);
    onFieldChange("defaultValue", value);
  };

  return (
    <>
      <div className="dui-example-field">
        <div className="dui-example-field-title">
          {t("quickOption")}: <span className="dui-required-field">*</span>
        </div>
        <TextField
          field={field}
          value={defaultValue}
          onChange={handleDefaultValueChange}
        />
      </div>
    </>
  );
};

export default AddBooleanTextField;
